export interface ISortOption {
  value: any;
  label: string;
  icon: string;
  iconColour?: string;
  image?: string;
}

export interface ISortMainImage {
  src: string;
  maxWidth: number;
}
